import { render, staticRenderFns } from "./StepsAndActivationCodeButtons.vue?vue&type=template&id=4f72bbc0"
import script from "./StepsAndActivationCodeButtons.vue?vue&type=script&lang=js"
export * from "./StepsAndActivationCodeButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports